import { render, staticRenderFns } from "./SwitcherButton.vue?vue&type=template&id=a91c3efa&scoped=true&"
import script from "./SwitcherButton.vue?vue&type=script&lang=js&"
export * from "./SwitcherButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitcherButton.vue?vue&type=style&index=0&id=a91c3efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91c3efa",
  null
  
)

export default component.exports